import React, { useRef } from "react";
import PropTypes from "prop-types";
import i18n from "micro-i18n";
import Modal, { ModalDirection } from "components/modal/Modal";
import { IconClose } from "components/icons/Icons";
import Compliance from "components/compliance/Compliance";
import ShareTools from "components/sharing/ShareTools";
import { handleNoShiftKeyCodeTriggers, handleShiftKeyCodeTriggers, isNullOrUndefOrEmpty, onFocusRef } from "utils";
import { KeyboardEventKeyCode } from "consts";
import classNames from "classnames";
import { connect } from "unistore/preact";
import { actions } from "actions";

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/sharing/ShareModal.scss';

const ShareModal = ({
  id,
  complianceUrl,
  showModal,
  onClose,
  theme,
  closeFocusRef,
  focusable = false,
  shareableLink,
}) => {
  if (
    isNullOrUndefOrEmpty(id) ||
    isNullOrUndefOrEmpty(shareableLink) ||
    isNullOrUndefOrEmpty(onClose) ||
    isNullOrUndefOrEmpty(closeFocusRef)
  ) {
    return null;
  }
  const modalFocusRef = useRef(null);
  const closeButtonBottomRef = useRef(null);

  const onTabKey = (event, focusRef, checkShift = false) => {
    const shiftKeyHandler = checkShift ? handleShiftKeyCodeTriggers : handleNoShiftKeyCodeTriggers;

    return shiftKeyHandler(event, [KeyboardEventKeyCode.Tab], () => onFocusRef(focusRef));
  };

  return (
    <Modal
      id={id}
      className="csw-share-modal"
      showModal={showModal}
      direction={ModalDirection.Right}
      onClose={onClose}
      theme={theme}
      openFocusRef={modalFocusRef}
      closeFocusRef={closeFocusRef}
      focusable={focusable}
      ariaLabeledById={`${id}-heading`}
    >
      <header
        ref={modalFocusRef}
        tabIndex="-1"
        id={`${id}-header`}
        onKeyDown={(e) => onTabKey(e, closeButtonBottomRef, true)}
      >
        <span role="heading" aria-level="1" id={`${id}-heading`}>
          {i18n.t("SHARE_MODAL_TITLE")}
        </span>
        <button
          type="button"
          className="csw-share-btn csw-btn csw-btn-icon outline"
          onClick={onClose}
          aria-label={i18n.t("SHARE_MODAL_CLOSE")}
          title={i18n.t("SHARE_MODAL_CLOSE")}
        >
          <IconClose />
          <span className="sr-only">{i18n.t("SHARE_MODAL_CLOSE")}</span>
        </button>
      </header>

      <div className="csw-modal-scroll">
        <ShareTools />
      </div>

      <footer
        className={classNames("csw-share-modal-footer", {
          "csw-flex-end": isNullOrUndefOrEmpty(complianceUrl),
        })}
      >
        {!isNullOrUndefOrEmpty(complianceUrl) && <Compliance complianceUrl={complianceUrl} />}
        <button
          type="button"
          className="csw-share-btn csw-modal-footer-btn csw-btn csw-btn-icon outline sr-only sr-only-focusable"
          ref={closeButtonBottomRef}
          onKeyDown={(e) => onTabKey(e, modalFocusRef)}
          onClick={onClose}
          aria-label={i18n.t("SHARE_MODAL_CLOSE")}
          title={i18n.t("SHARE_MODAL_CLOSE")}
        >
          <IconClose />
          <span className="sr-only">{i18n.t("SHARE_MODAL_CLOSE")}</span>
        </button>
      </footer>
    </Modal>
  );
};

ShareModal.propTypes /* remove-proptypes */ = {
  id: PropTypes.string.isRequired,
  complianceUrl: PropTypes.string,
  showModal: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  theme: PropTypes.string,
  closeFocusRef: PropTypes.object.isRequired,
  focusable: PropTypes.bool,
  shareableLink: PropTypes.object,
};

export default connect("shareableLink", actions)(ShareModal);
